export default "__VITE_ASSET__XLGYSF8F__"